// extracted by mini-css-extract-plugin
export default {"select":"select-module___select___f49463ef","arrow":"select-module___arrow___f5748466"};